export const Application: string = 'Application';

export const Profile: string = 'Profile';

// Dashboard
export const Confirmation: string = 'Confirmation';

export const Team: string = 'Team';

export const HackPass: string = 'HackPass';

export const BusDeposit: string = 'Bus Deposit';

export const Search: string = 'Search';

export const SponsorOnboarding: string = 'Onboarding';

export const Checkin: string = 'Check In';

// Confirm Attendence
export const ConfirmPresence: string = 'Confirm presence | McHacks';

export const ConfirmHeader: string = 'Confirm your Attendance';

export const ConfirmDeadLine: string =
  'Please confirm your attendance before Friday, January 25, 2019.';

export const ConfirmParagraph: string =
  'We are excited to offer you a spot at McHacks.';

export const Liability: string = 'Liability and Photo Release';

export const LegalReview: string =
  '*Students under the age of 18 must have their parent or legal guardian review the following document.';

// Confirm Account

export const ConfirmAccount: string = 'Account Confirmed';

export const ConfirmMessage: string =
  'Your account was successfully created! Click continue to update your profile and manage your application.';

export const Continue: string = 'Continue';

export const UnableConfirm: string = 'Unable to confirm account';

export const Error: string =
  'Something went wrong when we made your account. Please try again later.';

export const CreateAccount: string = 'Create account';

export const Confirming: string = 'Confirming...';

export const ConfirmLink: string = '/';

export const AttemptingLink: string = '/account/create';
